import React, { useState, ChangeEvent, FocusEvent } from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { TextFieldProps } from '@material-ui/core';

interface LastNameInputProps {
  value: string;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  errorsArr: string[];
  setErrorsArr: React.Dispatch<React.SetStateAction<string[]>>;
}

const LastNameInput: React.FC<LastNameInputProps> = ({
  value, 
  handleChange, 
  errorsArr, 
  setErrorsArr
}) => {
  const [error, setError] = useState<boolean>(false);
  const [helperText, setHelperText] = useState<string>('');

  const validateLastName = (name: string): void => {
    if (name.length < 2) {
      setError(true);
      const tempErrorsArr = errorsArr.filter(i => i !== 'lastName');
      setErrorsArr([...tempErrorsArr, "lastName"]);
      setHelperText("Please provide a last name of two characters or more.");
      return;
    } 
    
    setError(false);
    setHelperText(""); 
    const tempErrorsArr = errorsArr.filter(i => i !== 'lastName');
    setErrorsArr([...tempErrorsArr]);    
  };

  return (
    <Grid item xs={12}>
      <TextField
        autoComplete="family-name"
        name="lastName"
        variant="outlined"
        value={value}
        required
        fullWidth
        id="lastName"
        label="Last Name"
        error={error}
        helperText={helperText}
        onChange={handleChange}
        onBlur={(e: FocusEvent<HTMLInputElement>) => validateLastName(e.target.value)}
      />
    </Grid>
  );
};

export default LastNameInput;